<mat-form-field appearance="outline" floatLabel="always">
  <input matInput [matDatepicker]="picker" [formControl]="date" />
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker [calendarHeaderComponent]="monthDayHeader"></mat-datepicker>
</mat-form-field>
